<script>
    export let currentTime;
    export let currentDuration;

    $: {
        if (document.getElementsByClassName('indicator-back')[0]) {
            const indicatorWidth = document.getElementsByClassName('indicator-back')[0].clientWidth;
            const indicatorProgressWidth = (currentTime / currentDuration) * indicatorWidth;
            const currentIndicator = document.getElementsByClassName('indicator-front')[0];
            const handleIndicator = document.getElementsByClassName('indicator-handle')[0];
            currentIndicator.style.width = `${indicatorProgressWidth}px`;
            handleIndicator.style.left = `${indicatorProgressWidth}px`;
        }
    }

    function formatTime(time) {
        const minutes = Math.floor(time / 60);
        const seconds = Math.floor(time - minutes * 60);
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    }
</script>

<div>
    <div class="indicator-back">
        <div class="indicator-front"></div>
        <div class= "indicator-handle"></div>
    </div>
    <div class="text-s" style="display: flex; justify-content: space-between; margin-top: 9px">
        <div>{formatTime(currentTime)}</div>
        <div>{formatTime(currentDuration)}</div>
    </div>
</div>

<style>
    .indicator-back {
        position: relative;
        height: 1px;
        flex-grow: 1;
        background-color: var(--black-100);
    }

    .indicator-front {
        position: absolute;
        top: -1px;
        background-color: var(--black-100);
        height: 3px;
        width: 1%;
    }

    .indicator-handle{
        position: absolute;
            background-color: var(--black-100);
        height: 19px;
        width: 1px;
        top: -10px;
    }
</style>
